import { useState } from 'react';
import {
  Select,
  Box,
  useColorModeValue,
} from '@chakra-ui/react';

const placeholders = {
  ItemName: { item: '%event:view:item%', label: 'Last Viewed Item Name' },
  ItemDesc: { item: '%event:view:desc%', label: 'Last Viewed Item Desc' },
  ItemURL: { item: '%event:view:url%', label: 'Last Viewed Item URL' },
  ItemImage: { item: '%event:view:img%', label: 'Last Viewed Item Image' },
  ItemCount: { item: '%event:view:count%', label: 'Item view count for last hour' },
  ProductName: { item: '%event:productview:item%', label: 'Last Viewed Product Item Name' },
  ProductDesc: { item: '%event:productview:desc%', label: 'Last Viewed Product Item Desc' },
  ProductURL: { item: '%event:productview:url%', label: 'Last Viewed Product Item URL' },
  ProductImage: { item: '%event:productview:img%', label: 'Last Viewed Product Item Image' },
  ProductImageAsGif: { item: '%event:productview:gif%', label: 'Last Viewed Product Item Image As GIF' },
  ProductCount: { item: '%event:productview:count%', label: 'Product view count for last hour' },
  AddToCartItemName: { item: '%event:addtocart:item%', label: 'Last Added To Cart Item Name' },
  AddToCartItemDesc: { item: '%event:addtocart:desc%', label: 'Last Added To Cart Item Desc' },
  AddToCartItemURL: { item: '%event:addtocart:url%', label: 'Last Added To Cart Item URL' },
  AddToCartItemImage: { item: '%event:addtocart:img%', label: 'Last Added To Cart Item Image' },
  AddToCartItemImageAsGif: { item: '%event:addtocart:gif%', label: 'Last Added To Cart Item Image as GIF' },
  SearchedText: { item: '%event:search:value%', label: 'Last Searched Text' },
  InvoiceUrl: { item: '%event:buy:invoice_url%', label: 'Invoice Url for last order' },
  CheckoutUrl: { item: '%event:addtocart:checkout_url%', label: 'Last Added To Cart Checkout Url' },
  Username: { item: '%u%', label: 'Username' },
  Description: { item: '%d%', label: 'Description' },
  Email: { item: '%e%', label: 'Email' },
  Phone: { item: '%ph%', label: 'Phone' },
  ItemReview: { item: '%review%', label: 'Item Review' },
  BuyOrderItemName: { item: '%event:buy:order_name%', label: 'Buy Order Item Name' },
  BuyOrderStatusURL: { item: '%event:buy:order_status_url%', label: 'Buy Order Status Url' },
  CashOnDeliveryURL: { item: '%event:cash_on_delivery:url%', label: 'Cash On Delivery Url' },
  CashOnDeliveryOrderName: { item: '%event:cash_on_delivery:order_name%', label: 'Cash On Delivery Order Name' },
  EventCheckoutUrlName: { item: '%event::checkout_url%', label: 'Event Checkout Url' },
  FirstName: { item: '%firstname%', label: 'First Name' },
  DomainName: { item: '%domain_name%', label: 'Domain Name' },
  DomainUrl: { item: '%domain:url%', label: 'Domain Url' },
};

function PlaceholderInserter({ setFieldValue }) {
  const [value, setValue] = useState('');

  const selectBg = useColorModeValue('blue.50', 'blue.900');
  const selectBorder = useColorModeValue('blue.200', 'blue.700');
  const textColor = useColorModeValue('blue.700', 'blue.200');

  const handleChange = (e) => {
    const selectedValue = e.target.value;
    if (selectedValue) {
      setFieldValue(selectedValue);
      setValue(''); // reset select after inserting
    }
  };

  return (
    <Box minW="140px" maxW="140px">
      <Select
        placeholder="placeholders"
        value={value}
        onChange={handleChange}
        size="sm"
        bg={selectBg}
        borderColor={selectBorder}
        color={textColor}
        _placeholder={{ color: 'gray.500' }}
        borderRadius="md"
        fontSize="13px"
        height="32px"
        px={2}
        // Makes it look more button-like and compact
        _focus={{
          borderColor: 'blue.400',
          boxShadow: '0 0 0 2px rgba(66, 153, 225, 0.3)',
        }}
      >
        {Object.entries(placeholders).map(([key, { item, label }]) => (
          <option key={key} value={item}>
            {key} — {label}
          </option>
        ))}
      </Select>
    </Box>
  );
}

export default PlaceholderInserter;